module.exports = __webpack_public_path__ + "img/sideicon5.753e0b79.png";